import { BreakdownWithImage, SOMATIC_KEYS } from "../../../../shared";
import img from "./img.png";

export const WithoutStress = ({ onNextStep, onTrackEvent }) => {
  const readyToLoseAnswer = localStorage.getItem(SOMATIC_KEYS.weightChange);
  const isStruggleToGain = readyToLoseAnswer === "STRUGGLE_WITH_WEIGHT_GAIN";

  const title = isStruggleToGain
    ? "Get toned and fit without added stress"
    : "Lose excess weight without added stress";

  const paragraphText = isStruggleToGain
    ? "stress-free lifestyle"
    : "weight loss";

  const handleContinue = () => {
    onNextStep?.();
    onTrackEvent?.();
  };

  const paragraph = [
    "Dealing with constant stress can lead to sugar cravings and stress eating, but you can combat it with workout exercises. ",
    `<strong>Personal workout plan</strong> is your secret to healthy ${paragraphText}. It helps relieve stress, keep you motivated, and boost mindfulness.`
  ];
  return (
    <BreakdownWithImage
      img={img}
      title={title}
      paragraph={paragraph}
      onContinue={handleContinue}
    />
  );
};
